function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoPersonalArchitectWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 633 104",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M16.999,40L16.999,104L0.999,88L0.999,40L16.999,40Z",
    style: {
      fill: "white",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.999,24L80.999,72L64.999,88L64.999,33.06L40.999,18.66L16.999,33.06L16.999,40L0.999,40L0.999,24L40.999,0L80.999,24Z",
    style: {
      fill: "white",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.999,72L64.999,88L24.999,88L40.999,72L64.999,72Z",
    style: {
      fill: "white",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 352.869,
    y: 24,
    width: 8.13,
    height: 47.995,
    style: {
      fill: "white"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M328.414,71.995C321.309,71.995 316.899,68.15 316.899,61.956C316.899,55.857 320.904,51.812 330.299,50.492C335.759,49.722 339.054,49.257 339.054,46.103C339.054,43.228 336.709,41.508 332.779,41.508C328.459,41.508 326.134,43.093 325.684,46.343L318.544,46.343C319.094,39.853 324.399,35.999 332.849,35.999C342.399,35.999 346.849,39.873 346.849,48.188L346.849,66.591L346.874,72L339.949,72C339.714,71.59 339.454,69.86 339.184,67.806L339.129,67.371C337.599,69.655 334.374,71.995 328.414,71.995ZM338.499,53.057C337.069,53.892 334.874,54.407 332.749,54.902L332.259,55.017C328.009,55.977 324.759,57.897 324.759,61.756C324.759,64.986 326.734,66.621 330.629,66.621C336.289,66.621 339.254,62.176 339.254,58.661L339.254,52.622L338.499,53.057Z",
    style: {
      fill: "white",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M304.769,71.995L304.769,49.727C304.769,45.593 302.229,42.918 298.294,42.918C293.959,42.918 290.814,46.458 290.814,51.337L290.814,71.99L282.684,71.99L282.684,35.994L290.614,35.994L290.614,41.633C292.964,37.944 297.194,35.994 301.519,35.994C308.219,35.994 312.904,41.088 312.904,48.383L312.904,71.99L304.769,71.99L304.769,71.995Z",
    style: {
      fill: "white",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M261.064,71.995C250.859,71.995 243.449,64.426 243.449,53.997C243.449,43.568 250.859,35.999 261.064,35.999C271.274,35.999 278.679,43.568 278.679,53.997C278.679,64.426 271.274,71.995 261.064,71.995ZM261.064,42.013C255.334,42.013 251.769,46.603 251.769,53.997C251.769,61.346 255.329,65.911 261.064,65.911C266.794,65.911 270.359,61.346 270.359,53.997C270.359,46.608 266.794,42.013 261.064,42.013Z",
    style: {
      fill: "white",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.449,71.995C216.299,71.995 211.374,67.326 210.599,60.231L218.089,60.846C218.829,64.581 220.849,66.551 225.314,66.551C229.579,66.551 232.124,64.886 232.124,62.091C232.124,58.801 228.544,57.522 224.404,56.757C223.834,56.652 223.249,56.542 222.659,56.427C216.429,55.207 210.844,53.532 210.844,46.513C210.844,39.933 215.904,36.004 224.374,36.004C232.544,36.004 237.689,39.788 238.584,46.413L231.324,46.413C230.789,42.983 228.524,41.378 224.239,41.378C220.229,41.378 217.829,42.993 217.829,45.703C217.829,48.597 221.329,49.237 225.379,49.977C226.129,50.117 226.909,50.257 227.694,50.417C234.124,51.762 239.444,54.087 239.444,61.416C239.449,67.846 233.954,71.995 225.449,71.995Z",
    style: {
      fill: "white",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.894,71.995L188.894,36.044L196.689,36.044L196.689,41.943C198.834,37.939 202.299,36.044 205.849,36.044C206.609,36.044 207.199,35.944 207.599,36.044L207.599,43.263C207.224,43.233 206.754,43.218 206.394,43.218C200.529,43.218 197.024,47.093 197.024,53.577L197.024,71.995L188.894,71.995Z",
    style: {
      fill: "white",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.289,71.995C158.909,71.995 151.934,64.246 151.934,53.622C151.934,43.408 158.869,35.999 168.419,35.999C178.604,35.999 184.739,43.368 184.899,55.742L159.864,55.742L159.934,56.307C160.669,62.131 163.969,65.951 169.224,65.951C172.654,65.951 175.004,64.531 176.209,61.721L184.239,61.721C182.624,67.98 176.834,71.995 169.289,71.995ZM168.549,42.048C163.849,42.048 160.994,44.673 160.069,49.842L159.964,50.432L176.399,50.432L176.364,49.902C176.074,45.203 172.934,42.048 168.549,42.048Z",
    style: {
      fill: "white",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.999,71.995L112.999,24L133.579,24C138.854,24 142.959,25.46 145.774,28.345C148.494,31.129 149.929,34.794 149.929,38.938C149.929,47.987 143.974,53.607 134.384,53.607L122.069,53.607L122.069,71.99L112.999,71.99L112.999,71.995ZM122.069,46.688L132.639,46.688C137.829,46.688 140.929,43.813 140.929,39.003C140.929,34.279 137.879,31.454 132.774,31.454L122.069,31.454L122.069,46.688Z",
    style: {
      fill: "white",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M627.799,71.985C624.504,71.985 618.969,70.98 618.969,64.231L618.969,41.043L614.204,41.043L614.204,36.004L618.969,36.004L618.969,24.005L626.894,24.005L626.894,35.999L632.999,35.999L632.999,41.038L626.894,41.038L626.894,62.281C626.894,64.846 628.249,66.201 630.814,66.201C631.544,66.201 632.444,66.176 632.999,66.156L632.999,71.98C632.199,72.02 630.389,71.985 627.799,71.985Z",
    style: {
      fill: "white",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M597.628,72C587.528,72 580.473,64.111 580.473,53.697C580.473,43.283 587.333,36.004 597.158,36.004C605.193,36.004 610.778,40.333 612.204,47.623L604.273,47.623C603.458,44.388 600.868,42.318 597.563,42.318C591.953,42.318 588.738,46.463 588.738,53.692C588.738,60.921 591.903,65.681 597.428,65.681C601.373,65.681 603.643,63.561 604.383,59.841L612.204,59.841C611.344,67.141 605.778,72 597.628,72Z",
    style: {
      fill: "white",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M561.862,72C551.482,72 544.507,64.251 544.507,53.627C544.507,43.413 551.442,36.004 560.992,36.004C571.178,36.004 577.313,43.373 577.473,55.747L552.437,55.747L552.507,56.312C553.242,62.136 556.542,65.956 561.797,65.956C565.227,65.956 567.578,64.536 568.783,61.726L576.813,61.726C575.203,67.985 569.408,72 561.862,72ZM561.127,42.053C556.427,42.053 553.572,44.678 552.647,49.847L552.542,50.437L568.978,50.437L568.943,49.907C568.653,45.208 565.512,42.053 561.127,42.053Z",
    style: {
      fill: "white",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M537.302,71.985C534.007,71.985 528.472,70.98 528.472,64.231L528.472,41.043L523.707,41.043L523.707,36.004L528.472,36.004L528.472,24.005L536.397,24.005L536.397,35.999L542.502,35.999L542.502,41.038L536.397,41.038L536.397,62.281C536.397,64.846 537.752,66.201 540.317,66.201C541.047,66.201 541.947,66.176 542.502,66.156L542.502,71.98C541.702,72.02 539.892,71.985 537.302,71.985Z",
    style: {
      fill: "white",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M511.576,72L511.576,36.004L519.706,36.004L519.706,72L511.576,72ZM511.576,31.194L511.576,24.005L519.706,24.005L519.706,31.194L511.576,31.194Z",
    style: {
      fill: "white",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M497.446,72L497.446,49.732C497.446,45.598 494.906,42.923 490.971,42.923C486.636,42.923 483.491,46.463 483.491,51.342L483.491,71.995L475.361,71.995L475.361,24L483.491,24L483.491,41.438C486.031,37.729 489.926,35.999 494.196,35.999C500.896,35.999 505.577,41.093 505.577,48.388L505.577,71.995L497.446,71.995L497.446,72Z",
    style: {
      fill: "white",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M463.426,60.336L471.361,60.336C469.931,67.625 464.351,71.955 456.315,71.955C446.49,71.955 439.63,64.681 439.63,54.262C439.63,54.162 439.63,54.057 439.635,53.957C439.63,53.857 439.63,53.752 439.63,53.652C439.63,43.233 446.49,35.959 456.315,35.959C464.351,35.959 469.931,40.288 471.361,47.578L463.426,47.578C462.616,44.343 460.021,42.273 456.716,42.273C451.11,42.273 447.89,46.423 447.89,53.652C447.89,53.757 447.89,53.857 447.895,53.957C447.89,54.057 447.89,54.157 447.89,54.262C447.89,61.491 451.11,65.641 456.716,65.641C460.021,65.641 462.616,63.571 463.426,60.336Z",
    style: {
      fill: "white",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M418.925,71.955L418.925,36.004L426.72,36.004L426.72,41.903C428.865,37.899 432.33,36.004 435.88,36.004C436.64,36.004 437.23,35.904 437.63,36.004L437.63,43.223C437.255,43.193 436.785,43.178 436.425,43.178C430.56,43.178 427.055,47.053 427.055,53.537L427.055,71.955L418.925,71.955Z",
    style: {
      fill: "white",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M408.369,72L405.329,60.791L388.284,60.791L385.304,72L376.999,72L392.449,24.005L401.284,24.005L416.92,72L408.369,72ZM396.774,32.134L394.389,39.863L390.144,54.337L403.404,54.337",
    style: {
      fill: "white",
      fillRule: "nonzero"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoPersonalArchitectWhite);
export default __webpack_public_path__ + "static/media/logo-personal-architect-white.6122e0fd7fe3c038001ad167419f0eb7.svg";
export { ForwardRef as ReactComponent };